module.exports = __webpack_public_path__ + "static/media/silhouette.77bb9934.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/silhouette.png
 ** module id = 2361
 ** module chunks = 44
 **/